import styled from 'styled-components';

import { flexStart } from '../../style/reusableStyle';

export const TechnicianJobDetailsContainerStyled = styled.div`
  & .section-title {
    margin-bottom: 20px;
  }
  padding-bottom: 60px;
`;

export const UploadedLogosContainerStyled = styled.div`
  ${flexStart};
  gap: 20px;
`;
